export default "__VITE_ASSET__BXNGOcZI__"